"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _filters = require("../../../config/filters");
var _OperatorsDropdown = require("../../OperatorsDropdown");
var _ValuesDropdown = _interopRequireDefault(require("../../ValuesDropdown"));
var _types = require("../../types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TrashIcon = function TrashIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 3.947C7 2.704 8.143 2 9.143 2h5.714c1 0 2.143.704 2.143 1.947V5h3a1 1 0 1 1 0 2h-.198l-.75 13.114A2 2 0 0 1 17.056 22H6.945a2 2 0 0 1-1.997-1.886L4.198 7H4a1 1 0 0 1 0-2h3V3.947zM9 5h6V4H9v1zM6.202 7l.743 13h10.11L17.8 7H6.202zM10 9a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1z"
  }));
};
TrashIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "custom-field-conditions": "custom-field-conditions_3WcRgv",
  "customFieldConditions": "custom-field-conditions_3WcRgv",
  "custom-field-conditions-title": "custom-field-conditions-title__KSwGr",
  "customFieldConditionsTitle": "custom-field-conditions-title__KSwGr",
  "trash-icon": "trash-icon_DuLE_U",
  "trashIcon": "trash-icon_DuLE_U",
  "custom-field-conditions-dropdowns": "custom-field-conditions-dropdowns_FjnmXg",
  "customFieldConditionsDropdowns": "custom-field-conditions-dropdowns_FjnmXg",
  "button-as-anchor": "button-as-anchor_2nDOII",
  "buttonAsAnchor": "button-as-anchor_2nDOII"
}; 
require('./CustomFieldConditions.css');
const CustomFieldConditions = /*#__PURE__*/(0, _react.forwardRef)(({
  filter,
  onChange,
  onRemove
}, ref) => {
  const onOperatorChange = (0, _react.useCallback)(operator => onChange(_objectSpread(_objectSpread({}, filter), {}, {
    operator
  })), [onChange, filter]);
  const onValueChange = (0, _react.useCallback)(value => onChange(_objectSpread(_objectSpread({}, filter), {}, {
    value
  })), [onChange, filter]);
  const customFieldType = filter.customField.dataType;
  const options = _filters.CUSTOM_FIELDS_OPERATORS_MAPPING[customFieldType];
  const defaultValue = _types.CUSTOM_FIELD_LIST_TYPES.includes(customFieldType) ? _types.CustomFieldOperator.Contains : _types.CustomFieldOperator.Equals;
  const title = filter.customField.displayName;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.customFieldConditions,
    ref: ref,
    tabIndex: -1,
    "data-test-id": "custom-field-conditions"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.customFieldConditionsTitle
  }, /*#__PURE__*/_react.default.createElement("span", null, title), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    "aria-label": `Delete ${title}`,
    className: styles.buttonAsAnchor,
    onClick: () => onRemove(filter)
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.trashIcon,
    size: "xs"
  }, /*#__PURE__*/_react.default.createElement(TrashIcon, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.customFieldConditionsDropdowns
  }, /*#__PURE__*/_react.default.createElement(_OperatorsDropdown.OperatorsDropdown, {
    options: options,
    onChange: onOperatorChange,
    defaultValue: defaultValue,
    value: filter.operator
  }), /*#__PURE__*/_react.default.createElement(_ValuesDropdown.default, {
    options: filter.customField.values,
    dataType: filter.customField.dataType,
    onSubmit: onValueChange,
    values: filter.value,
    tagKey: filter.customField.tagKey
  })));
});
var _default = exports.default = CustomFieldConditions;
//# sourceMappingURL=CustomFieldConditions.js.map